import { FC } from "react";
import useI18n from "../../hooks/useTranslations";
import { Item } from "../../http/types/items";
import ModalDialog from "../ui/ModalDialog";
import ItemPage from "./ItemPage";

type ItemDialogProps = {
  item?: Item;
  onClose: () => void;
};

const ItemDialog: FC<ItemDialogProps> = ({ item, onClose }) => {
  const i18n = useI18n();

  return (
    <ModalDialog
      title={item?.code}
      onClose={onClose}
      actions={[{ title: i18n.translation.common.close, onClick: onClose }]}
      isSubmitting={false}
    >
      <ItemPage item={item} variant="dialog" />
    </ModalDialog>
  );
};

export default ItemDialog;
